import OpportunitiesFilter from './OpportunitiesFilter';

export default OpportunitiesFilter;
